module.exports = __webpack_public_path__ + "static/media/IMG_2364.43b41534.JPG";